<template>
  <form @submit.prevent="vLaunchRateResearch">
    <div class="rate-research">
      <div class="form-field">
        <label>{{$_('product_reference')}}*</label>
        <SelectAutocomplete
          delay="300"
          :itemoption="['TMOD', 'TMOD']"
          @autocomplete:selected="vSelectedStore('fmod', $event.TMOD)"
          :ajax="true"
          :func="vSearchProduct"
        />
      </div>
       <div class="form-field">
        <label>{{$_('size')}}*</label>
        <SelectAutocomplete
          delay="300"
          :itemoption="['TTAIL', 'TTAIL']"
          @autocomplete:selected="vSelectedStore('ftail', $event.TTAIL)"
          :ajax="true"
          :func="vSearchSize"
        />
      </div>
      <div class="form-field">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectAutocomplete from "@/common/components/widget/Autocomplete/SelectAutocomplete";
import rateService from '../services/rateService.js';

export default {
  name: 'RateResearch',
  components: {
    SelectAutocomplete
  },
  methods: {
    vLaunchRateResearch() {
      this.$store.dispatch('tarif/LAUNCH_RESEARCH', {launch: true});
      this.$store.dispatch('tarif/SELECT', {key: 'reset_rate_list', value: true});
    },
    vSelectedStore(key, value) {
      if(key === 'fmod') {
        value = value.toUpperCase();
      }
      this.$store.dispatch('tarif/SELECT', {key, value});
    },
    vSearchProduct(query) {

      let pnlot = this.$store.getters['tarif/get_pnlot'];

      return rateService.getProduct(query, pnlot)
      .then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      })
    },
    vSearchSize(query) {

      let pnlot = this.$store.getters['tarif/get_pnlot'];
      let fmod = this.$store.getters['tarif/get_fmod'];

      return rateService.getProductSize(query, pnlot, fmod)
      .then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      })
    }
  }
};
</script>

<style scoped>
.rate-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
/deep/
.autocomplete .autocomplete-field input {
  text-transform: uppercase;
}
</style>